import {createAsyncThunk} from "@reduxjs/toolkit";
import apiInstanceV2 from "../../Apis/AxiosV2";
import { USER_SERVICE } from "../EndPoints";

export const GetAllUserFiles = createAsyncThunk(
    'userFileSection/getAllUserFiles',
    async (userId, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .get(`${USER_SERVICE.getAllUserFiles}${userId}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);
